<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>

    <div v-if="changed">
      <div class="m-auto text-right pt-3">
        <el-button
          v-if="displayName !== 'starterplan shop owner'"
          @click="dialogFormVisible2 = true"
          type="primary"
          size="medium"
        >
          <i class="el-icon-plus mr-2"></i>Add User</el-button
        >
      </div>
      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Add User"
          :visible.sync="dialogFormVisible2"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add User</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <el-form
              :model="formdata"
              status-icon
              :rules="rules2"
              ref="formdata"
              label-width="120px"
              :label-position="labelPosition"
              size="medium"
              style="
                <!-- border: 1px solid #e2e2e2;
                border-radius: 5px; -->
                background-color: #fff;
                padding: 25px;
              "
            >
              <el-form-item
                label="Name"
                prop="name"
                :rules="[
                  { required: true, message: 'User name', trigger: 'blur' },
                ]"
              >
                <el-input placeholder="Name" v-model="formdata.name"></el-input>
              </el-form-item>

              <el-form-item
                label="System ID (non-editable)"
                prop="sysid"
                :rules="[
                  { required: true, message: 'System ID', trigger: 'blur' },
                ]"
              >
                <el-input
                  placeholder="System ID"
                  v-model="formdata.sysid"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Telephone Without 0"
                prop="telephone"
                :rules="[
                  { required: true, message: 'Telephone' },
                  { type: 'number', message: 'telephone no must be a number' },
                ]"
              >
                <el-input
                  v-model.number="formdata.telephone"
                  auto-complete="off"
                  placeholder="Telephone"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="User Role"
                prop="role"
                :rules="[
                  { required: true, message: 'User role', trigger: 'change' },
                ]"
              >
                <el-select
                  v-model="formdata.role"
                  placeholder="User Role"
                  @change="handleSelect"
                >
                  <el-option value="Admin">Admin</el-option>
                  <el-option value="Cashier">Cashier</el-option>
                  <el-option value="Shop Manager">Manager</el-option>
                  <el-option value="Technician">Technician</el-option>
                  <el-option v-if="shopCategory === 'Food / Restaurants'" value="Service Staff">Service Staff</el-option>
                  <el-option v-if="shopCategory === 'Food / Restaurants'" value="Kitchen Staff">Kitchen Staff</el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="formdata.role !== 'Admin'"
                label="Select Store"
                prop="store"
                :rules="[
                  {
                    required: true,
                    message: 'Select Store',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  multiple
                  v-model="formdata.store"
                  placeholder="Select Store"
                >
                  <el-option
                    v-for="item in $store.state.stores"
                    :key="item.value"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="City/Town" prop="city">
                <el-input
                  placeholder="City/Town"
                  v-model="formdata.city"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                label="Email"
                :rules="[
                  {
                    type: 'email',
                    message: 'Please input correct email address',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  placeholder="Email"
                  type="email"
                  v-model="formdata.email"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if="
                  formdata.role !== 'Admin'
                "
                label="Permissions List"
              >
                <el-checkbox-group v-model="formdata.permissions">
                  <el-checkbox
                    v-for="permission in permissionsList"
                    :label="permission"
                    :key="permission"
                    >{{ permission }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="Notes" prop="note">
                <el-input type="textarea" v-model="formdata.note"></el-input>
              </el-form-item>

              <!-- <el-form-item label="Password" prop="pass">
                <el-input
                  placeholder="Password"
                  type="password"
                  v-model="formdata.pass"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="Confirm Password" prop="checkPass">
                <el-input
                  placeholder="Confirm Password"
                  type="password"
                  v-model="formdata.checkPass"
                  auto-complete="off"
                ></el-input>
              </el-form-item> -->

              <el-form-item class="pt-2" style="margin-bottom: 0px">
                <el-button type="primary" @click="submitForm('formdata')"
                  >Add</el-button
                >
                <el-button @click="resetForm('formdata')">Reset</el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogFormVisible2 = false"
              >Cancel</el-button
            >
            <!-- <el-button type="primary" @click="submitForm('formdata')">Add</el-button> -->
          </span>
        </el-dialog>
      </div>
      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Edit User"
          :visible.sync="dialogFormVisible3"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add User</h4> -->
          <el-form
            :model="formdata2"
            status-icon
            :rules="rules2"
            ref="formdata2"
            label-width="120px"
            :label-position="labelPosition"
            size="medium"
            style="
              border: 1px solid #e2e2e2;
              border-radius: 5px;
              background-color: #fff;
              padding: 25px;
            "
          >
            <el-form-item
              label="Name"
              prop="name"
              :rules="[
                { required: true, message: 'User name', trigger: 'blur' },
              ]"
            >
              <el-input placeholder="Name" v-model="formdata2.name"></el-input>
            </el-form-item>

            <el-form-item
              label="System ID"
              prop="sysid"
              :rules="[
                { required: true, message: 'System ID', trigger: 'blur' },
              ]"
            >
              <el-input
                disabled
                placeholder="System ID"
                v-model="formdata2.sysid"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="Telephone Without 0"
              prop="telephone"
              :rules="[
                { required: true, message: 'Telephone' },
                { type: 'number', message: 'telephone no must be a number' },
              ]"
            >
              <el-input
                v-model.number="formdata2.telephone"
                auto-complete="off"
                placeholder="Telephone"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="User Role"
              prop="role"
              :rules="[
                { required: true, message: 'User role', trigger: 'change' },
              ]"
            >
              <el-select
                v-model="formdata2.role"
                placeholder="User Role"
                @change="handleSelect"
              >
                <el-option value="Admin">Admin</el-option>
                <el-option value="Cashier">Cashier</el-option>
                <el-option value="Shop Manager">Manager</el-option>
                <el-option value="Technician">Technician</el-option>
                <el-option v-if="shopCategory === 'Food / Restaurants'" value="Service Staff">Service Staff</el-option>
                <el-option v-if="shopCategory === 'Food / Restaurants'" value="Kitchen Staff">Kitchen Staff</el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formdata2.role !== 'Admin'"
              label="Select Store"
              prop="store"
              :rules="[
                { required: true, message: 'Select Store', trigger: 'change' },
              ]"
            >
              <el-select
                multiple
                v-model="formdata2.store"
                placeholder="Select Store"
              >
                <el-option
                  v-for="item in $store.state.stores"
                  :key="item.value"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="City/Town" prop="city">
              <el-input
                placeholder="City/Town"
                v-model="formdata2.city"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="email"
              label="Email"
              :rules="[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                placeholder="Email"
                type="email"
                v-model="formdata2.email"
              ></el-input>
            </el-form-item>

            <el-form-item
              v-if="
                formdata2.role !== 'Admin'
              "
              label="Permissions List"
            >
              <el-checkbox-group v-model="formdata2.permissions">
                <el-checkbox
                  v-for="permission in permissionsList"
                  :label="permission"
                  :key="permission"
                  >{{ permission }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="Notes" prop="note">
              <el-input type="textarea" v-model="formdata2.note"></el-input>
            </el-form-item>

            <el-form-item class="pt-2" style="margin-bottom: 0px">
              <el-button type="primary" @click="update('formdata2')"
                >Update</el-button
              >
              <!-- <el-button @click="resetForm('formdata2')">Reset</el-button> -->
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogFormVisible3 = false"
              >Cancel</el-button
            >
            <!-- <el-button type="primary" @click="submitForm('formdata')">Add</el-button> -->
          </span>
        </el-dialog>
      </div>
      <b-container class="col-lg-10 mt-1">
        <h3 class="text-info text-center my-4">Users</h3>
        <!-- User Interface controls -->
        <b-row>
          <b-col sm="4" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="5" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">Sort By</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group horizontal class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :dark="false"
            :small="true"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :empty-text="emptyText"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <!-- <template slot="index" slot-scope="data">
          {{data.index + 1}}
        </template> -->

            <template slot="id" slot-scope="row">
              <div>{{ row.value }}</div>
            </template>

            <template slot="actions" slot-scope="row">
              <!-- <div class="btn-group" role="group" aria-label="Basic example">

              <a @click.stop="row.toggleDetails"><el-button type="primary" size="mini">View</el-button></a>
              <a :href="`tel:${row.item.telephone}`" ><el-button type="success" size="mini">Call</el-button></a>
              <a :href="`sms:${row.item.telephone}`"><el-button type="info" size="mini">SMS</el-button></a>

          </div> -->
              <div class="btn-group" role="group" aria-label="Basic example">
                <el-button
                  type="primary"
                  size="small"
                  class="mt-1 d-block mx-auto"
                  @click="showUpdate(row.item)"
                  >Edit Details</el-button
                >
              </div>
            </template>
          </b-table>
        </el-card>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
const items = [];
export default {
  name: "users",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (this.formdata.checkPass !== "") {
          this.$refs.formdata.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.formdata.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    const defaultPermissions = [
      "invoice list",
      "invoice write",
      "quotation list",
      "quotation write",
      "cash flow",
      "expenses",
    ];
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "id", label: "User Id", sortable: true },
        { key: "sysid", label: "System ID", sortable: false },
        { key: "telephone", label: "Telephone", sortable: false },
        { key: "role", label: "Role", sortable: true },
        { key: "city", label: "City", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "regdate", label: "Registered", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      permissionsList: [
        "dashboard",
        "analytics",
        "invoice list",
        "invoice write",
        "invoice return",
        "GRN list",
        "GRN return",
        "GRN write",
        "quotation list",
        "quotation write",
        "cash flow",
        "expenses",
        "suppliers",
        "customers",
        "users",
        "online store",
        "stores",
        "settings",
        "products",
        "categories",
      ],

      displayName: firebase.auth().currentUser.displayName,
      payments: [],
      amount: 0,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      shopCategory: "",
      formdata: {
        name: "",
        telephone: "",
        email: "",
        sysid: "",
        role: "",
        store: [],
        city: "",
        note: "",
        permissions: defaultPermissions,
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      formdata2: {
        name: "",
        email: "",
        city: "",
        telephone: "",
        id: "",
        sysid: "",
        role: "",
        store: [],
        note: "",
        permissions: defaultPermissions,
      },
      labelPosition: "top",
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error",
      });
    },
    open2() {
      this.$notify.error({
        title: "Error",
        message: "System ID already taken",
        type: "error",
      });
    },
    showUpdate(item) {
      this.formdata2.name = item.name || "";
      this.formdata2.telephone = item.telephone || "";
      this.formdata2.email = item.email || "";
      this.formdata2.city = item.city || "";
      this.formdata2.id = item.id;
      this.formdata2.sysid = item.sysid;
      this.formdata2.role = item.role;
      this.formdata2.store = item.store;
      this.formdata2.note = item.note;
      this.formdata2.permissions = item.permissions;
      this.dialogFormVisible3 = true;
    },
    update(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          (this.dialogFormVisible3 = false), (this.changed = false);
          this.loading = true;
          let sysidTaken;
          let userId;
          const docRef = this.$store.state.secondaryDatabase.collection("sysusers");
          let firestoreQuery = docRef;
          if(this.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
          }
          firestoreQuery
            .where("sysid", "==", this.formdata2.sysid)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                sysidTaken = doc.data().sysid;
                userId = doc.id;
              });
              // console.log(sysidTaken, userId);
              if (
                sysidTaken === this.formdata2.sysid &&
                userId !== this.formdata2.id
              ) {
                this.loading = false;
                this.changed = true;
                return this.open2();
              }
              if (this.formdata2.role === "Admin" && firebase.auth().currentUser.displayName === 'shop owner')
                this.formdata2.permissions = this.permissionsList;
              if (this.formdata2.role === "Admin" && firebase.auth().currentUser.displayName === 'starterplan shop owner')
                this.formdata2.permissions = this.$store.state.starterPlanPermissionsList;
              this.$store.state.secondaryDatabase
                .collection("sysusers")
                .doc(this.formdata2.id)
                .update({
                  name: this.formdata2.name,
                  email: this.formdata2.email,
                  sysid: this.formdata2.sysid,
                  role: this.formdata2.role,
                  store: this.formdata2.store,
                  city: this.formdata2.city,
                  telephone: this.formdata2.telephone,
                  note: this.formdata2.note,
                  permissions: this.formdata2.permissions,
                })
                .then((docRef) => {
                  //console.log('docref', docRef.id)
                  var newitems = this.items.filter((item) => {
                    ////console.log('filfkkk')
                    if (item.id == this.formdata2.id) {
                      item.name = this.formdata2.name;
                      item.telephone = this.formdata2.telephone;
                      item.email = this.formdata2.email;
                      item.city = this.formdata2.city;
                      item.sysid = this.formdata2.sysid;
                      item.role = this.formdata2.role;
                      item.store = this.formdata2.store;
                      item.note = this.formdata2.note;
                      item.permissions = this.formdata2.permissions;
                    }
                    return item;
                  });
                  this.$store.state.users = newitems;
                  this.formdata2.name = "";
                  this.formdata2.telephone = "";
                  this.formdata2.email = "";
                  this.formdata2.city = "";
                  this.formdata2.id = "";
                  this.formdata2.sysid = "";
                  this.formdata2.role = "";
                  this.formdata2.store = "";
                  this.formdata2.note = "";
                  this.formdata2.permissions = [];
                  this.loading = false;
                  this.changed = true;
                  this.$notify({
                    title: "Success",
                    message: "User updated",
                    type: "success",
                  });
                })
                .catch((error) => alert(error));
            })
            .catch((error) => alert(error.message));
        } else {
          this.open1();
          return false;
        }
      });
    },
    handleSelect(value) {
      this.formdata.role = value;
    },
    submitForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          this.dialogFormVisible2 = false;
          this.changed = false;
          this.loading = true;
          let sysidTaken;
          const docRef = this.$store.state.secondaryDatabase.collection("sysusers");
          let firestoreQuery = docRef;
          if(this.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
          }
          firestoreQuery
            .where("sysid", "==", this.formdata.sysid)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                sysidTaken = doc.data().sysid;
                // console.log(sysidTaken);
              });
              if (sysidTaken === this.formdata.sysid) {
                this.loading = false;
                this.changed = true;
                return this.open2();
              }
              ////console.log(user)
              if (this.formdata2.role === "Admin" && firebase.auth().currentUser.displayName === 'shop owner')
                this.formdata2.permissions = this.permissionsList;
              if (this.formdata2.role === "Admin" && firebase.auth().currentUser.displayName === 'starterplan shop owner')
                this.formdata2.permissions = this.$store.state.starterPlanPermissionsList;
              this.$store.state.secondaryDatabase
                .collection("sysusers")
                .add({
                  name: this.formdata.name,
                  email: this.formdata.email,
                  city: this.formdata.city,
                  regdate: firebase.firestore.Timestamp.now(),
                  //uid: firebase.auth().currentUser.uid,
                  shopOwner: firebase.auth().currentUser.uid,
                  telephone: this.formdata.telephone,
                  sysid: this.formdata.sysid,
                  role: this.formdata.role,
                  store: this.formdata.store,
                  note: this.formdata.note,
                  permissions: this.formdata.permissions,
                })
                .then((docRef) => {
                  //console.log('docref', docRef.id)
                  this.$store.state.users.push({
                    id: docRef.id,
                    name: this.formdata.name,
                    note: this.formdata.note,
                    email: this.formdata.email,
                    city: this.formdata.city,
                    sysid: this.formdata.sysid,
                    role: this.formdata.role,
                    store: this.formdata.store,
                    permissions: this.formdata.permissions,
                    regdate: firebase.firestore.Timestamp.now()
                      .toDate()
                      .toLocaleString(),
                    //uid: firebase.auth().currentUser.uid,
                    telephone: this.formdata.telephone,
                  });
                  this.items = this.$store.state.users;
                  this.totalRows = this.items.length;
                  this.users = this.users + 1;
                  this.$store.state.secondaryDatabase
                    .collection("shops")
                    .doc(firebase.auth().currentUser.uid)
                    .update({
                      users: this.users,
                    })
                    .then(() => {
                      //console.log('secondaryDB shop id')
                    })
                    .catch((error) => alert(error));
                  this.formdata.name = "";
                  this.formdata.email = "";
                  this.formdata.telephone = "";
                  this.formdata.city = "";
                  this.formdata.role = "";
                  this.formdata.store = "";
                  this.formdata.sysid = "";
                  this.formdata.note = "";
                  this.formdata.permissions = [];
                  this.loading = false;
                  this.changed = true;
                  this.$notify({
                    title: "Success",
                    message: "User added",
                    type: "success",
                  });
                })
                .catch((error) => alert(error));
            })
            .catch((error) => alert(error));
        } else {
          this.open1();
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase
      .collection("shops")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then((doc) => {
        this.users = doc.data().users || 0;
        this.shopCategory = doc.data().cat
      })
      .catch((error) => alert(error));

    if (this.$store.state.users.length != 0) {
      this.items = this.$store.state.users;
      this.loading1 = false;
      this.changed = true;
    } else {
      const docRef = this.$store.state.secondaryDatabase.collection("sysusers");
      let firestoreQuery = docRef;
      if(this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
      }
      firestoreQuery
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              name: doc.data().name,
              email: doc.data().email,
              city: doc.data().city,
              regdate: doc.data().regdate,
              telephone: doc.data().telephone,
              sysid: doc.data().sysid,
              role: doc.data().role,
              store: doc.data().store,
              note: doc.data().note,
              permissions: doc.data().permissions,
            };
            if (data.regdate != undefined) {
              data.regdate = doc.data().regdate.toDate().toLocaleString();
            }
            this.items.push(data);
            this.$store.state.users = this.items;
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading1 = false;
          this.changed = true;
        });
    }
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/Users.vue